<template>
  <div class="detail" v-loading.fullscreen.lock="loading">
    <div class="bread">
      <img src="/static/img/fh.png" alt="">
      <ul class="con">
        <li><router-link :to="'/'">首页</router-link>-</li>
        <li><router-link :to="'/goods'">出售大厅</router-link>-</li>
        <li class="current">详细资料</li>
      </ul>
    </div>

    <div class="sec">
      <top :title="'活动详情'"></top>
      <div class="con" v-html="act_info.buy_info"></div>
    </div>

    <div class="sec">
      <top :title="'会员详细资料'"></top>
      <div class="con">
        <ul class="tw">
          <li class="pic-text">
            <span class="label">会员账号</span>
            <span class="text">{{info.account}}</span>
          </li>
          <template v-if="act_info.sale_extend">
            <li class="pic-text">
              <span class="label">VIP等级</span>
              <span class="text">{{info.vip_level}}</span>
            </li>
            <li class="pic-text">
              <span class="label">电子等级</span>
              <span class="text">{{info.e_level}}</span>
            </li>
            <!-- <li class="pic-text">
              <span class="label">真人等级</span>
              <span class="text">{{info.r_level}}级</span>
            </li> -->
            <li class="pic-text">
              <span class="label">电子晋级礼金</span>
              <span class="text">￥{{info.e_up_reward}}元</span>
            </li>
            <li class="pic-text" v-if="config_info.week_salary_status === '1'">
              <span class="label">电子周俸禄</span>
              <span class="text">￥{{info.e_week_reward}}元</span>
            </li>
            <li class="pic-text" v-if="config_info.month_salary_status === '1'">
              <span class="label">电子周月俸禄</span>
              <span class="text">￥{{info.e_month_reward}}元</span>
            </li>
            <!-- <li class="pic-text">
              <span class="label">真人晋级礼金</span>
              <span class="text">￥{{info.r_up_reward}}元</span>
            </li> -->
            <!-- <li class="pic-text">
              <span class="label">真人月俸禄</span>
              <span class="text">￥{{info.r_month_reward}}元</span>
            </li> -->
            <!-- <li class="pic-text">
              <span class="label">电子棋牌累计有效投注</span>
              <span class="text">￥{{info.e_bet_amount||0}}元</span>
            </li> -->
            <!-- <li class="pic-text">
              <span class="label">真人累计有效投注</span>
              <span class="text">￥{{info.r_bet_amount||0}}元</span>
            </li> -->
          </template>
          <template v-if="!act_info.sale_extend">
            <li class="pic-text">
              <span class="label">等级</span>
              <span class="text">{{info.e_level}}级</span>
            </li>
            <li class="pic-text">
              <span class="label">等级礼金</span>
              <span class="text">{{info.e_level}}级</span>
            </li>
            <li class="pic-text" v-if="config_info.week_salary_status === '1'">
              <span class="label">周俸禄</span>
              <span class="text">￥{{info.e_week_reward}}元</span>
            </li>
            <li class="pic-text" v-if="config_info.month_salary_status === '1'">
              <span class="label">月俸禄</span>
              <span class="text">￥{{info.e_month_reward}}元</span>
            </li>
          </template>
            <li class="pic-text">
              <span class="label">一口价</span>
              <span class="text">￥{{info.sale_price}}元</span>
            </li>
            <li class="pic-text">
              <span class="label">发布时间</span>
              <span class="text">{{info.created_at*1000 | formatDate}}</span>
            </li>
          <!-- <li class="pic-text">
            <span class="label">真人周俸禄</span>
            <span class="text">￥{{info.r_week_reward}}元</span>
          </li> -->
          <!-- <li class="pic-text">
            <span class="label">成交时间</span>
            <span class="text" v-if="info.deal_at==0">-</span>
            <span class="text" v-else>{{info.deal_at*1000 | formatDate}}</span>
          </li> -->
          <!-- <li class="pic-text">
            <span class="label">状态</span>
            <span class="text">{{info.status}}</span>
          </li>
          待审核；审核中；审核失败；交易成功 -->
        </ul>
        <div class="bar" v-if="userInfo">
          <button class="btn" @click="goBuy" v-show="showBtn">我要买</button>
          <button class="btn" @click="goBid" v-show="showBtn">我要出价</button>
          <router-link tag="button" class="btn" :to="'/sell'">我要卖</router-link>
        </div>
        <div class="bar" v-else>
          <button class="btn" @click="showLogin">我要买</button>
          <button class="btn" @click="showLogin">我要出价</button>
          <button class="btn" @click="showLogin">我要卖</button>
        </div>
      </div>
    </div>

    <div class="sec">
      <top :title="'活动细则'"></top>
      <div class="con" v-html="act_info.buy_rule"></div>
    </div>

    <el-dialog title="我要出价" :visible.sync="cjFormVisible" custom-class="dialog-t" width="890px" v-if="info">
      <div class="form" v-if="userInfo">
        <div class="input_text lef">
          <span class="label lar">账号ID</span>
          <span class="static">{{userInfo.username}}</span>
        </div>
        <div class="input_text lef">
          <span class="label lar">您想购买的账号</span>
          <input type="text" class="text" v-model="info.account" readonly>
        </div>
        <div class="input_text lef">
          <span class="label lar">您的出价</span>
          <input type="number" class="text" v-model="cj_form.price">
        </div>
        <div class="input_text lef">
          <span class="label lar">其他</span>
          <textarea class="textarea" v-model="cj_form.others"></textarea>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitBid">确认提交</el-button>
      </div>
    </el-dialog>

    <buy-dialog v-if="userInfo" :info="info" :tel="act_info.service_buy" ref="buyDialog" @submitbuy="submitBuy"></buy-dialog>
  </div>
</template>

<script>
import top from '@/components/common/top/top'
import buyDialog from '@/components/buyDialog/buyDialog'
import { mapState } from 'vuex'
import { saleResource, configResource, buyResource, priceResource } from '@/resource/resource'
import { formatDate } from '@/common/js/common'

const ERR_OK = 0

export default {
  name: 'detail',
  data () {
    return {
      info: {
        account: '-',
        vip_level: '-',
        e_level: '-',
        r_level: '-',
        e_up_reward: '-',
        e_week_reward: '-',
        e_month_reward: '-',
        r_up_reward: '-',
        r_week_reward: '-',
        r_month_reward: '-',
        sale_price: '-'
      },
      cjFormVisible: false,
      cj_form: {
        price: null,
        others: null
      },
      act_info: {
        service_buy: ''
      },
      loading: false,
      showBtn: true
    }
  },
  computed: {
    sale_price() {
      if (this.info.sale_price) {
        return '￥' + this.info.sale_price
      }
    },
    ...mapState(['userInfo', 'logined', 'config_info'])
  },
  created() {
    this.getRule()
    this.getInfo()
    if (Number(this.$route.query.code) === 1) {
      this.showBtn = false
    }
  },
  methods: {
    getRule() {
      this.loading = true
      configResource.config({ config: 'buy_rule,buy_info,service_buy,sale_extend' }).then(response => {
        response = response.body
        this.loading = false
        if (response.errcode === ERR_OK) {
          this.act_info = response.data
        }
      })
    },
    getInfo() {
      this.loading = true
      saleResource.detail(this.$route.params).then(res => {
        res = res.body
        this.loading = false
        if (res.errcode === ERR_OK) {
          this.info = res.data
        }
      })
    },
    showLogin() {
      this.$emit('showlogin', true)
    },
    goBuy() {
      this.$refs.buyDialog.showDialog(true)
    },
    submitBuy(data) {
      this.loading = true
      buyResource.buy(data).then(res => {
        res = res.body
        this.loading = false
        if (res.errcode === ERR_OK) {
          this.$alert(res.data, '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$refs.buyDialog.showDialog(false)
              this.$refs.buyDialog.clearForm()
            }
          })
        }
      })
    },
    goBid() {
      this.cjFormVisible = true
    },
    submitBid() {
      if (!this.cj_form.price) {
        this.$alert('您的出价不能为空', '温馨提示', {
          confirmButtonText: '确定'
        })
        return
      }
      if (Number(this.cj_form.price) < 0) {
        this.$alert('您的出价不能小于0', '温馨提示', {
          confirmButtonText: '确定'
        })
        this.cj_form.price = null
        return
      }
      let ret = {
        sale_id: this.info.id,
        price: this.cj_form.price,
        others: this.cj_form.others
      }
      this.loading = true
      priceResource.price(ret).then(res => {
        res = res.body
        this.loading = false
        if (res.errcode === ERR_OK) {
          this.$alert(res.data, '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.cjFormVisible = false
              this.cj_form = {
                price: null,
                others: null
              }
            }
          })
        }
      })
    }
  },
  filters: {
    formatDate(time) {
      let date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm')
    }
  },
  components: {
    top,
    buyDialog
  }
}
</script>

<style lang="stylus" scoped>
.detail
  width 1000px
  margin 0 auto
  .bread
    display flex
    align-items center
    margin-top 16px
    .con
      display flex
      margin-left 16px
      & > li
        color #626262
        font-size 14px
        & > a
          color #626262
          cursor pointer
      .current
        color $primary
  .sec
    .con
      padding 25px 40px
      color #626262
      font-size 14px
      line-height 22px
      border solid 1px #dcdcdc
      .im
        color rgb(255,0,0)
      .tw
        padding 35px 0
        & > li
          padding-left 105px
          margin-bottom 20px
          display flex
          .label
            color #959595
            font-size 14px
            width 90px
            text-align right
            margin-right 35px
          .text
            color #313131
            font-size 14px
      .bar
        text-align center
        margin-top 40px
        margin-bottom 20px
        .btn
          display inline-block
          height 40px
          text-align center
          background-color #efefef
          border solid 1px #dcdcdc
          width 159px
          color #434343
          font-size 16px
          line-height 40px
          margin-right 50px
          border-radius 2px
          cursor pointer
          outline none
          &:first-child
            background #f59c25
            border solid 1px #f59c25
            color #fff
          &:last-child
            background-color #288cea
            border solid 1px #288cea
            color #fff
</style>



// WEBPACK FOOTER //
// detail.vue?6fce61bc